/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SignOutIcon = /*#__PURE__*/ createSvgIcon(
  'SignOutIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.5 17c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 15.5v-11c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44h4.75c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H4.5v11h4.75c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535A.72.72 0 019.25 17H4.5zm9.625-6.25H8.749a.727.727 0 01-.534-.214.72.72 0 01-.215-.532c0-.21.072-.39.215-.535a.72.72 0 01.534-.219h5.376l-1.167-1.167a.73.73 0 010-1.064.731.731 0 011.063.002l2.458 2.458c.153.148.23.32.23.517a.722.722 0 01-.23.525l-2.458 2.458a.681.681 0 01-.521.219.794.794 0 01-.53-.24.745.745 0 01.01-1.062l1.145-1.146z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default SignOutIcon;
